window.eDaysUserResync = (function($, window, document) {

  var init = function() {
    initResyncButton();
  }

  var initResyncButton = function() {
    $('#resync-employee-e-days').on('click', function(e) {
      e.preventDefault();

      var button = $(this);
      var url = button.data('url');

      // Disable button and show loading state
      button.prop('disabled', true);
      button.text(button.data('syncing-text'));

      // Create a form and submit it to trigger the POST request
      // This allows the controller to handle redirect and flash messages normally
      var form = $('<form>', {
        'method': 'POST',
        'action': url
      });

      // Add CSRF token
      var csrfToken = $('meta[name="csrf-token"]').attr('content');
      form.append($('<input>', {
        'type': 'hidden',
        'name': 'authenticity_token',
        'value': csrfToken
      }));

      // Append form to body and submit
      $('body').append(form);
      form.submit();
    });
  }

  return {
    init: init
  };

})(jQuery, window, document);
